var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "eu-display_flex eu-column eu-justify_center eu-gap_3 dash-progress-bar",
    },
    [
      _c(
        "div",
        { staticClass: "eu-display_flex eu-align-items_center eu-gap_2" },
        [
          _vm._t("default"),
          _c("emd-text", { attrs: { "data-testid": "titleText" } }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "eu-display_flex eu-align-items_center eu-gap_2" },
        [
          _vm.showBackground
            ? _c(
                "emd-progress",
                { attrs: { max: _vm.$attrs.max } },
                [
                  _c(
                    "emd-progress-bar",
                    _vm._b(
                      { on: { emitterProgress: _vm.setProgress } },
                      "emd-progress-bar",
                      _vm.$attrs,
                      false
                    )
                  ),
                ],
                1
              )
            : _c(
                "emd-progress-bar",
                _vm._b(
                  { on: { emitterProgress: _vm.setProgress } },
                  "emd-progress-bar",
                  _vm.$attrs,
                  false
                )
              ),
          _vm.showCurrency
            ? _c(
                "span",
                {
                  staticClass: "percentage_span",
                  attrs: { "data-testid": "show-currency" },
                },
                [_vm._v(_vm._s(_vm.currency) + " ")]
              )
            : _c(
                "span",
                {
                  staticClass: "percentage_span",
                  attrs: { "data-testid": "show-progress" },
                },
                [_vm._v(_vm._s(_vm.progress) + " ")]
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }